import { PRIMER } from 'constants/store.constants';
import { STATUS_LOADING } from 'constants/statuses.constants';

const selectPrimersSlice = (state) => state[PRIMER];
export const selectPrimersWarnings = (state) => selectPrimersSlice(state).warnings;
export const selectPrimersLoading = (state) => selectPrimersSlice(state).status === STATUS_LOADING;
